<template>
  <div class="card-container">

    <v-btn v-if="showDeleteBtn" @click="deleteCard" color="error" style="right: -10px; top: -10px" fab small absolute top right>
      <v-icon>mdi-delete</v-icon>
    </v-btn>

    <div class="card-chip">
      <img src="@/assets/img/payment_card/card_chip.png" width="100%" />
    </div>

    <div class="card-number">
      <div class="number-section">****</div>
      <div class="number-section">****</div>
      <div class="number-section">****</div>
      <div class="number-section">{{last4Digits || '****'}}</div>
    </div>

    <div class="footer">

      <div class="holder">
        {{holder}}
      </div>

      <div class="brand-logo">
        <img :src="brandImg" width="100%"/>
      </div>

    </div>

    <kimsa-confirm
        ref="deleteModal"
        title="Eliminar medio de pago"
        content="Si tienes una subscripción activa será cancelada. ¿Deseas continuar?"
        confirm-label="Si, continuar"
        :loading="loadingDelete"
        :persistent="true"
        @confirm="deleteConfirm"
        :close-on-confirm="false"
    ></kimsa-confirm>

  </div>
</template>

<script>
import {mapMutations} from 'vuex'
import KimsaConfirm from '@/components/common/KimsaConfirm'
import {ApiUtils} from "@/utils/ApiUtils";

export default {
  name: "CreditCard",
  components: {KimsaConfirm},
  props:{
    showDeleteBtn:{
      type: Boolean,
      default: false
    },
    type: {
      type: String, //visa, mastercard, etc
      required: true
    },
    holder: {
      type: String,
      required: true
    },
    last4Digits: {
      type: String,
      required: true
    }
  },
  data(){
    return {
      loadingDelete: false
    }
  },
  methods:{
    ...mapMutations(['showSnackBar']),
    deleteCard() {
      const vm = this
      vm.$refs.deleteModal.show()
    },
    async deleteConfirm() {
      const vm = this
      vm.loadingDelete = true
      const endpoint = `providers/${vm.currentProvider.id}/subscription/reset`
      const response = await ApiUtils.makePost(endpoint)

      if(!response.ok){
        vm.loadingDelete = false
        const json = await response.json()
        return vm.toast(json.message || 'Ocurrío un error eliminando la tarjeta')
      }

      vm.$refs.deleteModal.hide()
      vm.toast('Haz eliminado el medio de pago', 'error')
      vm.loadingDelete = false
      vm.$emit('deleted')
    }
  },
  computed:{
    brandImg(){
      const vm = this
      /*
      * American Express, Diners Club, Discover, JCB, MasterCard, UnionPay, Visa, or Unknown
      * */
      switch(vm.type.toLowerCase()){
        case 'amex':
          return require('@/assets/img/payment_card/american_express.png')
        case 'diners':
          return require('@/assets/img/payment_card/diners_club.png')
        case 'discover':
          return require('@/assets/img/payment_card/discover.png')
        case 'jcb':
          return require('@/assets/img/payment_card/jcb.png')
        case 'mastercard':
          return require('@/assets/img/payment_card/mastercard.png')
        case 'visa':
          return require('@/assets/img/payment_card/visa.png')
        default:
          return require('@/assets/img/payment_card/unknown.png')
      }

    }
  }
}
</script>

<style scoped>

@import url('https://fonts.googleapis.com/css2?family=Roboto+Mono:ital,wght@0,300;0,400;1,300&display=swap');

.card-number,
.holder{
  text-shadow: 1px 1px 3px rgba(0,0,0,.9);
}

.card-number{
  position: absolute;
  display: flex;
  justify-content: center;
  top: 20%;
  left: 0;
  padding: 10px;
  color: #fff;
  width: 100%;
}

.card-number .number-section{
  flex: 1;
  padding: 2px;
  text-align: center;
  font-size: 1em;
}

.holder{
  flex: 5;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-left: 15px;
  font-family: 'Roboto Mono', monospace;
  font-size: 1em;
  font-weight: 500;
  color: white;
}

@media screen and (min-width: 321px){

  .card-number{
    top: 25%;
  }

  .holder{
    font-size: .8em;
  }

  .card-number .number-section{
    font-size: 1.3em;
  }
}

@media screen and (min-width: 500px){

  .holder{
    font-size: 1em;
  }

  .card-number{
    top: 30%;
  }

  .card-number .number-section{
    font-size: 1.5em;
  }
}

@media screen and (min-width: 700px){

  .holder{
    font-size: 1.4em;
  }

  .card-number{
    top: 35%;
  }

  .card-number .number-section{
    font-size: 1.8em;
  }
}

@media screen and (min-width: 900px){

  .holder{
    font-size: .8em;
  }

  .card-number{
    top: 35%;
  }

  .card-number .number-section{
    font-size: 1.5em;
  }
}

@media screen and (min-width: 1200px){

  .holder{
    font-size: 1em;
  }

  .card-number{
    top: 30%;
  }

  .card-number .number-section{
    font-size: 1.6em;
  }
}

.brand-logo{
  flex: 1;
  text-align: right;
}

.card-container{
  position: relative;
  background-color: var(--v-accent-base);
  border-radius: 10px;
  width: 100%;
  padding-top: 56.25%;
  background-image: url("../../assets/img/payment_card/card_background.png");
  background-position: center;
  background-size: cover;
  box-shadow: 10px 10px 25px rgba(0,0,0,.4);
}

.card-chip{
  padding: 5px;
  position: absolute;
  width: 15%;
  top: 5px;
  left: 5px;
  filter: brightness(0.9);
}

.chip-spacer{
  flex: 7;
}

.footer{
  position: absolute;
  padding: 10px;
  align-items: center;
  bottom: 5px;
  display: flex;
  left: 0;
  width: 100%;
}


</style>
